import React, { FC } from 'react';
import { Row, Col } from 'antd';

import './index.less';

interface UnitItemProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: string | React.ReactNode;
}

const UnitItem: FC<UnitItemProps> = ({
  children,
  label,
  className = '',
  ...rest
}) => {
  return (
    <Row className={`form-unit-item ${className}`} {...rest}>
      <Col span={10} className='form-unit-label'>
        {label}
        <em>{label ? ':' : ''}</em>
      </Col>
      <Col span={12} offset={1} className='form-unit-content'>
        {children}
      </Col>
    </Row>
  );
};

export default UnitItem;
